import { useSearchParams } from 'react-router';

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

export function DataTableViewByDate() {
  const [searchParams, setSearchParams] = useSearchParams();
  const viewBy = searchParams.get('view_by') ?? '';

  function onValueChange(value: 'start' | 'end' | 'none') {
    setSearchParams((prev) => {
      prev.set('page', '1');

      if (value === 'none') {
        prev.delete('view_by');
      } else {
        prev.set('view_by', value);
        prev.set('sort_by', value === 'start' ? 'starts_at' : 'ends_at');
        prev.set('sort_dir', 'desc');
      }

      return prev;
    });
  }

  return (
    <Select onValueChange={onValueChange} value={viewBy}>
      <SelectTrigger className="w-48">
        <SelectValue placeholder="View by" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="start">View by Start Date</SelectItem>
        <SelectItem value="end">View by End Date</SelectItem>
        <SelectItem value="none">Clear filter</SelectItem>
      </SelectContent>
    </Select>
  );
}
